import { createSlice } from "@reduxjs/toolkit";

const togglePrewievQr = createSlice({
  name: "togglePrewiev",
  initialState: {
    toggle: false,
    isLinksModal: false,
  },
  reducers: {
    truePrewievQrValue(state, { payload }) {
      state.toggle = true;
    },
    falsePrewievQrValue(state, { payload }) {
      state.toggle = false;
    },
    truePewievLinksModal(state) {
      state.isLinksModal = true;
    },
    falsePewievLinksModal(state) {
      state.isLinksModal = false;
    },
  },
});
export const { truePrewievQrValue, falsePrewievQrValue, truePewievLinksModal, falsePewievLinksModal } =
  togglePrewievQr.actions;
export default togglePrewievQr.reducer;
